/**
 * Small reusable badges/icons for the vehicle list & detail.
 * Şub 2026 — Vites + Yakıt görsel gösterimleri.
 */

// Küçük vites kolu (gear-shift) SVG'si. Otomatik ve manuel için farklı
// pattern kullanır (Automatic: P R N D; Manual: 6+R H-pattern).
export function TransmissionBadge({ value, size = 20 }) {
  if (!value) return <span className="text-slate-400" data-testid="veh-trans-none">-</span>;

  const isAuto = value === 'AUTOMATIC';
  const label = isAuto ? 'Otomatik' : 'Manuel';
  const tone = isAuto
    ? 'text-emerald-700 bg-emerald-50 border-emerald-300 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300'
    : 'text-indigo-700 bg-indigo-50 border-indigo-300 dark:bg-indigo-950/40 dark:border-indigo-800 dark:text-indigo-300';

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full border ${tone}`}
      style={{ width: size + 4, height: size + 4 }}
      title={label}
      data-testid={isAuto ? 'veh-trans-icon-auto' : 'veh-trans-icon-manual'}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={label}>
        {isAuto ? (
          <>
            {/* Otomatik: dikey çizgi + PRND noktaları + top */}
            <line x1="12" y1="4" x2="12" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="20" r="1.8" fill="currentColor" />
            <circle cx="12" cy="6" r="1.6" fill="currentColor" />
            <text x="15.5" y="7" fontSize="4" fontWeight="700" fill="currentColor">P</text>
            <text x="15.5" y="11" fontSize="4" fontWeight="700" fill="currentColor">R</text>
            <text x="15.5" y="15" fontSize="4" fontWeight="700" fill="currentColor">N</text>
            <text x="15.5" y="19" fontSize="4" fontWeight="700" fill="currentColor">D</text>
          </>
        ) : (
          <>
            {/* Manuel: H-pattern shift knob */}
            <line x1="7"  y1="7"  x2="7"  y2="17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <line x1="12" y1="7"  x2="12" y2="17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <line x1="17" y1="7"  x2="17" y2="17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <line x1="7"  y1="12" x2="17" y2="12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <circle cx="12" cy="6" r="2.2" fill="currentColor" />
          </>
        )}
      </svg>
    </span>
  );
}

// Yakıt tipi → renk + kısaltma etiketi haritası.
const FUEL_STYLES = {
  DIESEL:      { label: 'Diesel',     short: 'D',  cls: 'bg-slate-700 text-white border-slate-700' },
  BENZINE:     { label: 'Benzine',    short: 'B',  cls: 'bg-rose-100 text-rose-700 border-rose-300' },
  EV:          { label: 'Elektrik',   short: 'EV', cls: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
  HYBRID:      { label: 'Hybrid',     short: 'H',  cls: 'bg-teal-100 text-teal-700 border-teal-300' },
  LPG:         { label: 'LPG',        short: 'LPG',cls: 'bg-sky-100 text-sky-700 border-sky-300' },
  CNG:         { label: 'CNG',        short: 'CNG',cls: 'bg-purple-100 text-purple-700 border-purple-300' },
  RODE_MAZOUT: { label: 'Rode Mazout',short: 'RM', cls: 'bg-red-100 text-red-800 border-red-400' },
  YOK:         { label: 'Yok',        short: '×',  cls: 'bg-slate-100 text-slate-500 border-slate-300' },
};

// Küçük yakıt damlası ikonu (fuel drop / spark)
function FuelIcon({ type, size = 12 }) {
  if (type === 'EV') {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M13 3L4 14h7l-1 7 9-11h-7l1-7z" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3s-6 7-6 12a6 6 0 0012 0c0-5-6-12-6-12z" fill="currentColor" />
    </svg>
  );
}

export function FuelBadge({ value }) {
  if (!value) return <span className="text-slate-400" data-testid="veh-fuel-none">-</span>;
  const style = FUEL_STYLES[value] || { label: value, short: value.slice(0, 3), cls: 'bg-slate-100 text-slate-600 border-slate-300' };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-semibold ${style.cls}`}
      title={style.label}
      data-testid={`veh-fuel-${value}`}
    >
      <FuelIcon type={value} />
      {style.short}
    </span>
  );
}
